import axios from "axios";
import axiosRetry from "axios-retry";
import { takeEvery, put, call, select, all } from "redux-saga/effects";
import { getSessionIDFromState, getLang } from "../../util/helper";
import {
  SET_LANG_FAIL,
  SET_LANG_SUCCESS,
  SET_LANG_REQUEST,
  SKIP_FORM_FAIL_SAFE,
} from "../types";

axiosRetry(axios, {
  retries: 3,
  retryDelay: axiosRetry.exponentialDelay,
  retryCondition: () => true,
});

const modifyLang = (payload, session_id) => {
  return axios.request({
    method: "PUT",
    headers: { "x-access-token": session_id },
    data: payload,
    url: `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_ENV}/api/setLang`,
  });
};

function* setLang({ payload }) {
  try {
    const session_id = yield select(getSessionIDFromState);
    const res = yield call(modifyLang, payload, session_id);
    if (res.data) {
      yield put({
        type: SET_LANG_SUCCESS,
        payload: getLang(res.data.lang_id),
      });
    } else {
      yield all([
        put({ type: SET_LANG_FAIL, payload: res.error }),
        put({
          type: SKIP_FORM_FAIL_SAFE,
          payload: { err: res.error, errInfo: "setLangFailed" },
        }),
      ]);
    }
  } catch (error) {
    yield all([
      put({ type: SET_LANG_FAIL, payload: error }),
      put({
        type: SKIP_FORM_FAIL_SAFE,
        payload: { err: error, errInfo: "setLangFailed" },
      }),
    ]);
  }
}

function* updateLang() {
  yield takeEvery(SET_LANG_REQUEST, setLang);
}

export { updateLang };
